import React from "react";
import { connect } from "react-redux";
import { Result, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { goBack } from "connected-react-router";

const NoMatch = (props) => (
  <Result
    status="404"
    title="404"
    subTitle={
      <FormattedMessage
        id="messages.notFound"
        defaultMessage="Omlouváme se, hledaná stránka neexistuje."
      />
    }
    extra={
      <Button type="primary" onClick={() => props.goBack()}>
        <FormattedMessage id="messages.back" defaultMessage="Zpět" />
      </Button>
    }
  />
);

export default connect(null, { goBack })(NoMatch);
